import "@ui5/webcomponents-base/dist/Assets.js"; // Base i18n
import "@ui5/webcomponents-localization/dist/Assets.js"; // CLDR
import "@ui5/webcomponents-theming/dist/Assets.js"; // Theming
import "@ui5/webcomponents-icons/dist/Assets.js"; // Icons texts

// own main package assets
import "./generated/json-imports/Themes.js";
import "./generated/json-imports/i18n.js";
